let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9MyL2")).then(() => parcelRequire('kEB0s'));